var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { TextField, Select, Button, Tooltip, Modal, Checkbox } from '@cimpress/react-components';

var ConfigShippingView =
/** @class */
function (_super) {
  __extends(ConfigShippingView, _super);

  function ConfigShippingView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showDaysToDeliveryHelptText: false
    };

    _this.onClose = function () {
      var _a = _this.props,
          closeModal = _a.closeModal,
          onSubmit = _a.onSubmit;
      closeModal();
      onSubmit();
    };

    _this.showDaysToDeliveryHelpText = function () {
      _this.setState({
        showDaysToDeliveryHelptText: true
      });
    };

    _this.hideDaysToDeliveryHelpText = function () {
      _this.setState({
        showDaysToDeliveryHelptText: false
      });
    };

    return _this;
  }

  ConfigShippingView.prototype.render = function () {
    var _a = this.props,
        shippingTime = _a.shippingTime,
        onShippingTimeInputChange = _a.onShippingTimeInputChange,
        onChangeSaveShippingConfig = _a.onChangeSaveShippingConfig,
        isSaveShippingEnabled = _a.isSaveShippingEnabled,
        deliveryLocations = _a.deliveryLocations,
        onDeliveryLocationChange = _a.onDeliveryLocationChange,
        selectedDeliveryLocation = _a.selectedDeliveryLocation,
        onPostalCodeInputChange = _a.onPostalCodeInputChange,
        postalCode = _a.postalCode,
        city = _a.city,
        onCityInputChange = _a.onCityInputChange,
        closeModal = _a.closeModal,
        onResetAll = _a.onResetAll,
        open = _a.open,
        productionTime = _a.productionTime,
        fulfillmentLocations = _a.fulfillmentLocations,
        onFulfillmentLocationChange = _a.onFulfillmentLocationChange,
        selectedFulfillmentLocation = _a.selectedFulfillmentLocation;
    var toolTip = 'Shipping price will be calculated only if Total Delivery Days greater than Production Time';
    toolTip = productionTime ? toolTip + " (" + productionTime + " Days)" : toolTip;
    return React.createElement(Modal, {
      className: "modal-custom-style",
      show: open,
      onRequestHide: closeModal,
      title: "Configure Shipping",
      closeButton: true
    }, React.createElement("div", {
      className: "card card-custom-style"
    }, React.createElement("div", {
      className: "card-block"
    }, React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-10"
    }, React.createElement(Select, {
      label: "Ship To",
      value: selectedDeliveryLocation,
      options: deliveryLocations,
      onChange: onDeliveryLocationChange,
      required: true
    }))), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-10"
    }, React.createElement(TextField, {
      label: "City",
      value: city,
      onChange: onCityInputChange,
      disabled: !selectedDeliveryLocation,
      required: true
    }))), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-10"
    }, React.createElement(TextField, {
      label: "Postal Code",
      value: postalCode,
      onChange: onPostalCodeInputChange,
      disabled: !selectedDeliveryLocation || !city,
      required: true
    }))), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-10"
    }, React.createElement(Tooltip, {
      direction: "right",
      contents: toolTip,
      show: this.state.showDaysToDeliveryHelptText
    }, React.createElement(TextField, {
      label: "Total Delivery Days",
      type: "number",
      value: shippingTime,
      onChange: onShippingTimeInputChange,
      disabled: !postalCode || !selectedDeliveryLocation || !city,
      onFocus: this.showDaysToDeliveryHelpText,
      onBlur: this.hideDaysToDeliveryHelpText,
      required: true
    })))), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-10"
    }, React.createElement(Select, {
      label: "Fulfillment Location",
      value: selectedFulfillmentLocation,
      options: fulfillmentLocations,
      onChange: onFulfillmentLocationChange,
      required: true
    }))), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-10"
    }, React.createElement(Checkbox, {
      label: "Save as default configuration",
      checked: isSaveShippingEnabled,
      onChange: onChangeSaveShippingConfig,
      disabled: !shippingTime || !selectedDeliveryLocation || !postalCode || !city
    }))), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-12",
      style: {
        marginTop: '20px'
      }
    }, React.createElement(Button, {
      type: "default",
      onClick: onResetAll
    }, "Reset"), React.createElement(Button, {
      type: "default",
      className: "submit-button-style",
      onClick: this.onClose,
      disabled: !shippingTime || !selectedDeliveryLocation || !postalCode
    }, "Submit"))))));
  };

  return ConfigShippingView;
}(Component);

export default ConfigShippingView;